export const REDUCER_NAME = 'plan'

export const EXISTING_CONDITION = 'existingCondition'

export const DO_NOT_MOVE = 'doNotMove'

export const LEAVE_SPACES_OPEN = 'leaveSpacesOpen'

export const IPR_INSTRUCTION = 'iprInstructionList'

export const IPR_NOT_REQUIRED = 'iprNotRequired'

export const IS_IPR_INSTRUCTIONS_LIST_SAVED = 'isIprInstructionListSaved'

export const TREATMENT_TYPE = 'treatmentType'

export const TREATMENT_REASON = 'treatmentReason'

export const IPR_VALUE_LIST = [0, 1, 2, 3, 4, 5, 6].map(value => ({
    id: value,
    value: '0.' + value,
}))

export const INSTRUCTION_LIST = 'instructionList'

export const UPPER_TEETH = [
    '18',
    '17',
    '16',
    '15',
    '14',
    '13',
    '12',
    '11',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
]
export const UPPER_TEETH_FIRST_HALF = [
    '18',
    '17',
    '16',
    '15',
    '14',
    '13',
    '12',
    '11',
]
export const UPPER_TEETH_SECOND_HALF = [
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
]

export const UPPER_TEETH_IN_BETWEEN = [
    '18-17',
    '17-16',
    '16-15',
    '15-14',
    '14-13',
    '13-12',
    '12-11',
    '11-21',
    '21-22',
    '22-23',
    '23-24',
    '24-25',
    '25-26',
    '26-27',
    '27-28',
]

export const LOWER_TEETH = [
    '48',
    '47',
    '46',
    '45',
    '44',
    '43',
    '42',
    '41',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
]
export const LOWER_TEETH_FIRST_HALF = [
    '48',
    '47',
    '46',
    '45',
    '44',
    '43',
    '42',
    '41',
]
export const LOWER_TEETH_SECOND_HALF = [
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
]
export const LOWER_TEETH_IN_BETWEEN = [
    '48-47',
    '47-46',
    '46-45',
    '45-44',
    '44-43',
    '43-42',
    '42-41',
    '41-31',
    '31-32',
    '32-33',
    '33-34',
    '34-35',
    '35-36',
    '36-37',
    '37-38',
]



// WEBPACK FOOTER //
// ./src/modules/treatment/state/plan/const.js